import { Bot } from "lucide-react";

import { Badge } from "~/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/ui/table";
import { ClientApprovalRequest } from "~/types/clientApproval";
import { formatDate, formatRut } from "~/utils/helpers";

import { ApprovalStatusBadge } from "./ApprovalStatusBadge";

interface ApprovalsTableProps {
  requests: ClientApprovalRequest[];
  onRowClick: (request: ClientApprovalRequest) => void;
}

export function ApprovalsTable({ requests, onRowClick }: ApprovalsTableProps) {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Empresa</TableHead>
            <TableHead>RUT</TableHead>
            <TableHead>Contacto</TableHead>
            <TableHead>Teléfono</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Fecha</TableHead>
            <TableHead>Origen</TableHead>
            <TableHead>Estado</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {requests.map((request) => (
            <TableRow
              key={request.id}
              className="cursor-pointer hover:bg-muted/30"
              onClick={() => onRowClick(request)}
            >
              <TableCell className="font-medium">{request.name}</TableCell>
              <TableCell className="text-muted-foreground">
                {formatRut(request.tax_id)}
              </TableCell>
              <TableCell>{request.contact_person || "-"}</TableCell>
              <TableCell className="text-muted-foreground">
                {request.phone_number || "-"}
              </TableCell>
              <TableCell className="text-muted-foreground">
                {request.email || "-"}
              </TableCell>
              <TableCell className="whitespace-nowrap text-muted-foreground">
                {formatDate(request.created_at)}
              </TableCell>
              <TableCell>
                <Badge
                  variant="outline"
                  className="gap-1 border-violet-200 bg-violet-50 text-violet-700"
                >
                  <Bot className="h-3 w-3" />
                  IA
                </Badge>
              </TableCell>
              <TableCell>
                <ApprovalStatusBadge status={request.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
